import React from "react";
import Header from "../../components/Header";
import Hero from "../../components/Hero";
import Companies from "../../components/Companies";
import About from "../../components/About";
import Services from "../../components/Services";
import Tour from "../../components/Tour";
import Features from "../../components/Features";
import Cta from "../../components/Cta";
import Subscribe from "../../components/Subscribe";
import Footer from "../../components/Footer";
import Tab from "../../components/Tab";
import Logo from "../../img/logo.png";
import Contact from "../../components/Contact";

const HomePage = () => {
  return (
    <>
      <Header Logo={Logo} />
      <Hero />
      <Companies />
      <About />
      <Tab />
      <Services />
      <Tour />
      <Features />
      <Cta />
      {/* <Pricing /> */}
      {/* <Reviews /> */}
      {/* <LatestBlog /> */}
      <Contact />
      <Subscribe />
      <Footer />
    </>
  );
};
export default HomePage;
